const LabelMapper = {
  total: "Total",
  revenue: "Revenue",
  ratesAndAnnualCharges: "Rates and Annual charges",
  userChargesAndFees: "User charges and fees",
  interestAndInvestmentRevenue: "Interest and Investment revenue",
  otherRevenue: "Other revenue",
  grantsAndContributionsProvidedForOperating:
    "Grants and contributions Provided for operating Purposes",
  grantsAndContributionsProvidedForCapital:
    "Grants and contributions Provided for Capital Purposes",
  netGainsFromTheDisposalsOfAssets: "Net Gains from the Disposal of assets",
  NetShareOfInterestsInJointVenturesAndAssociates:
    "Net Share of Interests in Joint Ventures and Associates",
  expenses: "Expenses",
  employeeBenefitsAndOnCosts: "Employee Benefits and on Costs",
  borrowingCosts: "Borrowing Costs",
  materialsAndContracts: "Materials and contracts",
  depreciationAndAmortisation: "Depreciation and Amortisation",
  impairment: "Impairment",
  otherExpenses: "Other expenses",
  netLossesFromDisposalOfAssets: "Net Losses from Disposal of assets",
  operatingResult: "Operating result",
  assets: "Assets",
  currentAssets: "Current assets",
  nonCurrentAssets: "Non-current assets",
  miscellaneousNonCurrentAssets: "Miscellaneous Non-current assets",
  liabilities: "Liabilities",
  currentLiabilities: "Current liabilities",
  nonCurrentLiabilities: "Non-current liabilities",
  miscellaneousCurrentLiabilities: "Miscellaneous current liabilities",
  miscellaneousNonCurrentLiabilities: "Miscellaneous non-current liabilities",
  operatingPerformance: "Operating Performance",
  ownSourceOperatingRevenue: "Own Source operating revenue",
  unrestrictedCurrentRatio: "Unrestricted current ratio",
  debtServiceCoverRatio: "Debt service Cover ratio",
  ratesAndAnnualChargesOutstandingPercentage:
    "Rates and Annual charges Outstanding Percentage",
  cashExpenseCoverRatio: "Cash Expense Cover ratio",
  ordinaryRates: "Ordinary Rates",
  specialRates: "Special Rates",
  annualCharges: "Annual charges",
  specificUserCharges: "Specific User charges",
  statutoryAndRegulatoryCharges: "Statutory and Regulatory charges",
  otherCharges: "Other charges",
  cashAndCashEquivalents: "Cash and cash equivalents",
  currentInvestments: "Current Investments",
  currentReceivables: "Receivables",
  currentInventories: "Inventories",
  otherCurrentAssets: "Other current assets",
  nonCurrentAssetsHeldForSale: "Non-current assets Held for Sale",
  nonCurrentInvestments: "Non-current Investments",
  nonCurrentReceivables: "Non-current receivables",
  nonCurrentInventories: "Non-current Inventories",
  infrastructurePropertyPlantAndEquipment:
    "Infrastructure, property, plant and equipment",
  investmentsAccountedForUsingTheEquityMethod:
    "Investments Accounted for using the Equity method",
  investmentProperty: "Investment property",
  intangibleAssets: "Intangible assets",
  currentPayables: "Payables",
  currentBorrowings: "Current borrowings",
  currentProvisions: "Current provisions",
  incomeReceivedInAdvance: "Income Received in Advance",
  nonCurrentPayables: "Non-current Payables",
  nonCurrentBorrowings: "Non-current borrowings",
  nonCurrentProvisions: "Non-current provisions",
  // New for qld
  otherRevenues: "Other revenues",
  capitalExpenses: "Capital expenses",
  infrastructurePropertyPlantEquipment:
    "Infrastructure property plant equipment",
  operatingSurplusRatio: "Operating surplus ratio",
  grantsContributionsProvidedForOperating:
    "Grants contributions Provided For operating",
  averageOsr: "Average operating surplus ratio",
  grantsContributionsProvidedForCapital:
    "Grants contributions Provided For Capital",
  miscellaneous: "Miscellaneous",
  netFinancialLiabilities: "Net Financial liabilities",
  assetsustainabilityRatio: "Asset Sustainability ratio",
  averageAsr: "Average Asset Sustainability ratio",
  relativeRiskAssessment: "Relative Risk Assessment",
  averageRemainingUsefulLifeOfInfrastructureAssets:
    "Average Remaining useful life of infrastructure assets",
  _trend: "Should not be displayed",
  // new for health
  healthServiceFunding: "Health service funding",
  grantsAndOtherContributions: "Grants and other contributions",
  gainOnDisposalRevaluationOfAssets: "Gain on disposal/revaluation of assets",
  employeeExpenses: "Employee expenses",
  suppliesAndServices: "Supplies and services",
  operatingCashOutflows: "Operating cash outflows",
  grants: "Grants",
  currentEmployeeProvision: "Current employee provisions",
  depreciationAndAmmortisation: "Depreciation and ammortisation",
  impairmentLoss: "Impairment Loss",
  unrestrictedCash: "Unrestricted cash",
  restrictedCash: "Restricted cash",
  interestExpense: "Interest expenses",
  provisions: "Provisions",
  unearnedRevenueContractLiabilities: "Unearned revenue & contract liabilities",
  cashAvailableDays: "Cash available days",
  retainedSurplusExpenditure: "Retained surplus/expenditure",
  frontlineStaff: "Frontline staff",
  nonFrontLineStaff: "Non frontline staff",
  qwau: "QWAU",
  anticipatedMaintenance: `Anticipated maintenance`,
  activityBasedFuningAbf: "Activity Based funding (ABF)",
  // New for 2020 health
  currentLeaseLiabilities: "Current lease liabilities",
  netCashFromOperatingActivities: "Net cash from operating activities",
  otherCurrentLiabilities: "Other current liabilities",
  rightOfUseAssets: "Right of use assets",
  nonCurrentLeaseLiabilities: "Non-current lease liabilities",
  hospitalisations201819AllCausesCount: "Hospitalisations - all causes (count)",
  hospitalisations201819AllCausesAsr: "Hospitalisations - all causes (ASR)",
  potentiallyPreventable201819:
    "Percentage of hospitalisations potentially preventable",
  lifestyleRelated201819: "Percentage of hospitalisations lifestyle related",
  cancerIncidenceAllCancersCases20152017:
    "Cancer incidence - all cancers - cases (2015-2017)",
  cancerIncidenceAllCancersCrude20152017:
    "Cancer incidence - all cancers - crude (2015-2017)",
  interestBearingLiabilities: "Interest bearing liabilities",
};

const RegionMapper = {
  // "Other regional": "regional",
};

export const regionMatcher = (str) => {
  return RegionMapper[str] || str;
};

const prettifyLabel = (label) => {
  return label.replace(/\s-\s/g, "—");
};

const labelMatcher = (str) => {
  const label = LabelMapper[str];
  if (!label) {
    throw Error("Missing label for: " + str);
  }
  return prettifyLabel(label);
};
export default labelMatcher;



// WEBPACK FOOTER //
// ./src/helpers/label-mapper.js